class Nav {
  constructor(dom) {
    this.NAME = 'Nav';
    this.dom = dom;
    this.toggles = Array.from(dom.querySelectorAll('[data-nav-toggle]'));
  }

  init() {
    if (!this.toggles.length) return;

    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleItem(toggle);
      });
    });

    document.addEventListener('click', (event) => {
      if (!this.dom.contains(event.target)) this.closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeAll();
    });
  }

  toggleItem(toggle) {
    const item = toggle.closest('.theme-header__nav-item');
    const isOpen = item.classList.contains('is-open');

    this.closeAll();

    if (!isOpen) {
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  closeAll() {
    this.toggles.forEach((toggle) => {
      toggle.closest('.theme-header__nav-item').classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  }
}

export default Nav;
